


import * as dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isToday from "dayjs/plugin/isToday";
import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const useFilter = (data,itemsPerPage) => {

  const [filter, setFilter] = useState("");
  const [sortedField, setSortedField] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const [vendor, setVendor] = useState("");
  const [vendorRequest, setVendorRequest] = useState("");
  const [vehicleCategory, setVehicleCategory] = useState("");
  const [vehicletype, setVehicletype] = useState("");
  const [hourbasic, setHourBasic] = useState("");
  const [itinerarybasic, setItineraryBasic] = useState("");
  const [itineraryperiodic, setItineraryPeriodic] = useState("");  
  const [seoManageCity, setSeoManageCity] = useState("");  
  const [seoPage, setSeoPage] = useState("");  
  const [topselling, setTopselling] = useState("");
  const [booking, setBooking] = useState("");
  const [vehicle, setVehicle] = useState("");
  const [advertisement, setAdvertisement] = useState("");
  const [contact, setContact] = useState("");
  const [career, setCareer] = useState("");
  const [languagedriver, setLanguageDriver] = useState("");
  const [menu, setMenu] = useState("");
  const [razorpaydetails, setRazorpayDetails] = useState("");
  const [razorpayorderdetails, setRazorpayOrderDetails] = useState("");
  const [clientfeedback, setClientFeedback] = useState("");
  const [permit, setPermit] = useState("");
  const [partialpayment, setPartialPayment] = useState("");
  const [subusers, setSubusers] = useState("");
  const [billpaymentreport, setBillPaymentReport] = useState("");
  const [tripadvance, setTripadvance] = useState("");
  const [paymentdetails, setPaymentDetails] = useState("");
  const [jobtitle, setJobtitle] = useState("");
  const [vendorAllot ,setVendorAlot] = useState("");
  const [subscribe, setSubscribe] = useState("");
  const [hourPeriodicday, setHourPeriodicDay] = useState("");
  const [hourPeriodictime, setHourPeriodicTime] = useState("");
  const [daybasic, setDayBasic] = useState("");
  const [agent, setAgent] = useState("");
  const [vehicleAllot, setVehicleAllot] = useState("");
  
  const [airbasic, setAirBasic] = useState("");
  const [airPeriodicday, setAirPeriodicDay] = useState("");
  const [airPeriodictime, setAirPeriodicTime] = useState("");
  const [dayperiodic, setDayPeriodic] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");
  const [vehicleBrand, setVehicleBrand] = useState("");
  const [vehicleSeats, setVehicleSeats] = useState("");
  const [vehicleColor, setVehicleColor] = useState("");
  const [driver, setDriver] = useState("");
  const [purchasebill, setPurchaseBill] = useState("");
  const [driverqueue, setDriverqueue] = useState("");
  const [country, setCountry] = useState("");
  const [zone, setZone] = useState("");
  const [pending, setPending] = useState([]);
  const [processing, setProcessing] = useState([]);
  const [delivered, setDelivered] = useState([]);
  const [status, setStatus] = useState("");
  const [time, setTime] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [dataTable, setDataTable] = useState([]); //tableTable for showing on table according to filtering
  const [todayOrder, setTodayOrder] = useState("");
  const [monthlyOrder, setMonthlyOrder] = useState("");
  const [totalOrder, setTotalOrder] = useState("");
  const [isDisabled, ] = useState(false);
  const [newProducts] = useState([]);
  const currencyRef = useRef("");
  const bookingRef = useRef("");
  const driverRef = useRef("");
  const billRef = useRef("");
  const vendoralotRef = useRef("");
  const driverqueueRef = useRef("");
  const vehicleRef = useRef("");
  const advertisementRef = useRef("");
  const contactRef = useRef("");
  const careerRef = useRef("");
  const languagedriverRef = useRef("");
  const menuRef = useRef("");
  const razorpaydetailsRef= useRef("");
  const razorpayorderdetailsRef = useRef("");
  const clientfeedbackRef = useRef("");
  const permitRef = useRef("");
  const partialpaymentRef = useRef("");
  const subusersRef = useRef("");
  const billpaymentreportRef = useRef("");
  const tripadvanceRef = useRef("");
  const paymentdetailsRef = useRef("");
  const jobtitleRef = useRef("");
  const subscribeRef = useRef("");
  const SeoManageCityRef = useRef("");
  const seoPageRef = useRef("");
  const searchRef = useRef("");
  const userRef = useRef("");
  const vehicleCategoryRef = useRef("");
  const vehicleTypeRef = useRef("");
  const fixedItineraryRef = useRef("");
  const fixedItineraryPeriodicHikeRef = useRef("");
  const topSellingRef = useRef("");
  const hourRentalBasicRateRef = useRef("");   
  const dayRentalBasicRateRef = useRef("");
  const agentsRef = useRef("");
  const airportPickupBasicRateRef = useRef("");        
  const airportPickupPeriodicHikeDayRef = useRef("");    
  const airportPickupPeriodicHikeTimeRef = useRef("");
  const dayRentalPeriodicHikeDayRef = useRef("");
  const hourRentalPeriodicHikeDayRef = useRef("");
  const hourRentalPeriodicHikeTimeRef = useRef(""); 
  const vendorRef = useRef("");

  const vendorRequestRef = useRef("");
  const vehicleModelRef = useRef("");
  const vehicleBrandRef = useRef("");
  const vehicleSeatsRef = useRef("");
  const vehicleColorRef = useRef("");
  const couponRef = useRef("");
  const orderRef = useRef("");
  const categoryRef = useRef("");
  const attributeRef = useRef("");
  const countryRef = useRef("");
  const languageRef = useRef("");
  const taxRef = useRef("");

  const vehicleAllotRef = useRef("");

  dayjs.extend(isBetween);
  dayjs.extend(isToday);

  const location = useLocation();

  //service data filtering
  const serviceData = useMemo(() => {
    const date = new Date();
    date.setDate(date.getDate() - time);
  
    if (location.pathname === "/dashboard") {
      const orderPending = data?.filter(
        (statusP) => statusP.status === "Pending"
      );
      setPending(orderPending);
      const orderProcessing = data?.filter(
        (statusO) => statusO.status === "Processing"
      );
      setProcessing(orderProcessing);
      const orderDelivered = data?.filter(
        (statusD) => statusD.status === "Delivered"
      );
      setDelivered(orderDelivered);
      //daily total order calculation
      const todayServices = data?.filter((order) =>
        dayjs(order.createdAt).isToday()
      );
      const todayOrder = todayServices?.reduce(
        (preValue, currentValue) => preValue + currentValue.total,
        0
      );
      setTodayOrder(todayOrder);
      //monthly order calculation
      const monthlyServices = data?.filter((order) =>
        dayjs(order.createdAt).isBetween(
          new Date().setDate(new Date().getDate() - 30),
          new Date()
        )
      );
      const monthlyOrder = monthlyServices?.reduce(
        (preValue, currentValue) => preValue + currentValue.total,
        0
      );
      setMonthlyOrder(monthlyOrder);
      //total order calculation
      const totalOrder = data?.reduce(
        (preValue, currentValue) => preValue + currentValue.total,
        0
      );
      setTotalOrder(totalOrder);
    }
    if (searchUser) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      data = data.filter(
        (search) =>
          search?.Reference?.toLowerCase().includes(searchUser.toLowerCase()) ||
          search?.Customer?.toLowerCase().includes(searchUser.toLowerCase()) ||
          search?.Mobile?.toLowerCase().includes(searchUser.toLowerCase()) ||
          search?.Email?.toLowerCase().includes(searchUser.toLowerCase())||
          search?.City?.toLowerCase().includes(searchUser.toLowerCase())||
          search?.Status?.toLowerCase().includes(searchUser.toLowerCase())||
          ((search)?search["Login By"].toLowerCase().includes(searchUser.toLowerCase()):false) ||
          ((search)?search["Created Date"].toLowerCase().includes(searchUser.toLowerCase()):false) 
         
      );
    }
    if (vehicleCategory) {
      const searchTerms = vehicleCategory.toLowerCase().split(' ');
    
      const amenitiesMapping = {
        1: "AC",
        2: "Charger",
        3: "Music",
        4: "Carrier",
        5: "TV",
      };
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          (
           (search?.seats && search.seats.toLowerCase().includes(term)) ||
           (search?.similar_vehicle && search.similar_vehicle.toLowerCase().includes(term)) ||
           (search?.vehicle_type_name && search.vehicle_type_name.toLowerCase().includes(term)) ||
           (search?.amenities && search.amenities.some(amenity => 
             amenitiesMapping[amenity]?.toLowerCase().includes(term)
           ))
          )
        );
      }, data);
    }
    
    if (vehicletype) {
      data = data.filter(
        (search) =>
        ((search)?search["name"].toLowerCase().includes(vehicletype.toLowerCase()):false)
         
      );
    }  

 
    if (vehicleAllot) {
      const searchTerms = vehicleAllot.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.company_name && search.company_name.toLowerCase().includes(term)) || 
         (search?.client_name && search.client_name.toLowerCase().includes(term)) || 
         (search?.ref_no && search.ref_no.toLowerCase().includes(term)) ||
         (search?.vehicle_reg_no && search.vehicle_reg_no.toLowerCase().includes(term))  ||
         (search?.vehiclename && search.vehiclename.toLowerCase().includes(term)) ||
         (search?.driver_name && search.driver_name.toLowerCase().includes(term)) ||
         (search?.driver_contact_no && search.driver_contact_no.toLowerCase().includes(term)) ||
         (search?.start_date && search.start_date.toLowerCase().includes(term)) ||
         (search?.end_date && search.end_date.toLowerCase().includes(term)) 
        ));
      }, data); 
    }
    if (vendorAllot) {
     
      const searchTerms = vendorAllot.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
       
         (search?.ref_no && search.ref_no.toLowerCase().includes(term)) || 
         (search?.client_name && search.client_name.toLowerCase().includes(term)) || 
         (search?.departure_name && search.departure_name.toLowerCase().includes(term)) ||
         (search?.arrival_name && search.arrival_name.toLowerCase().includes(term)) ||
         (search?.package_type && search.package_type.toLowerCase().includes(term)) || 
         (search?.vendor_name && search.vendor_name.toLowerCase().includes(term)) || 
         (search?.vehiclename && search.vehiclename.toLowerCase().includes(term)) ||
         (search?.start_date && search.start_date.toLowerCase().includes(term))||
         (search?.end_date && search.end_date.toLowerCase().includes(term)) ||
         (search?.vendor_status && search.vendor_status.toLowerCase().includes(term)) 
        ));
      }, data); 
    }
    if (hourbasic) {  
      const searchTerms = hourbasic.toLowerCase().split(' ');
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ((search?.city && search.city.toLowerCase().includes(term)) || 
        (search?.vehicle_type_id && search.vehicle_type_id.some(id => {
          const typeName = search.vehicle_type_names[id];
          const prime = search.prime[id];
          const km4h40 = search['4h_40km']?.[id]?.toString().toLowerCase();
          const km6h60 = search['6h_60km']?.[id]?.toString().toLowerCase();
          const km8h80 = search['8h_80km']?.[id]?.toString().toLowerCase();
          const km10h100 = search['10h_100km']?.[id]?.toString().toLowerCase();
          const extraKm = search['extra_km']?.[id]?.toString().toLowerCase();
          const extraHr = search['extra_hr']?.[id]?.toString().toLowerCase();
          return (typeName && typeName.toLowerCase().includes(term)) ||
                 (prime && prime.toString().toLowerCase().includes(term)) ||
                 (km4h40 && km4h40.includes(term)) ||
                 (km6h60 && km6h60.includes(term)) ||
                 (km8h80 && km8h80.includes(term)) ||
                 (km10h100 && km10h100.includes(term)) ||
                 (extraKm && extraKm.includes(term)) ||
                 (extraHr && extraHr.includes(term));
        })))
        );
      }, data); 
    }
    
    if (itinerarybasic) {
      const searchTerms = itinerarybasic.toLowerCase().split(' '); 
    
      data = data.filter((search) => {
        return searchTerms.every(term => (
          (search?.package_code?.toLowerCase().includes(term)) ||
          (search?.route?.toLowerCase().includes(term)) ||
          (search?.vehicle_type?.some(id => {
            const typeName = search.vehicle_type_names[id];
            const prime = search.prime[id];
            const rate = search.rate[id];
            
            return (
              (typeName && typeName.toLowerCase().includes(term)) ||
              (prime && prime.toLowerCase().includes(term)) ||
              (rate && rate.toLowerCase().includes(term))
            );
          }))
        ));
      });
      
    }
    if (seoManageCity) {
      const searchTerms = seoManageCity.toLowerCase().split(' '); 
    
      data = data.filter((search) => {
        return searchTerms.every(term => (
          (search?.city_name?.toLowerCase().includes(term)) ||
          (search?.state_name?.toLowerCase().includes(term)) ||
          (search?.seo_active?.toString().includes(term)) ||
          (term === "active" ? search?.seo_active?.toString() === "true" : null)||
          (term === "inactive" ? search?.seo_active?.toString() === "false" : null)
        ));
      });
    }
    if (seoPage) {
      const searchTerms = seoPage.toLowerCase().split(' '); 
    
      data = data.filter((search) => {
        return searchTerms.every(term => (
          (search?.url?.toLowerCase().includes(term)) ||
          (search?.keywords?.toLowerCase().includes(term)) ||
          (search?.title?.toLowerCase().includes(term)) 
          
        ));
      });
    }

    if (topselling) {
      const searchTerms = topselling.toLowerCase().split(' '); 
    
      data = data.filter((search) => {
        return searchTerms.every(term => (
          (search?.package_code?.toLowerCase().includes(term)) ||
          (search?.route?.toLowerCase().includes(term)) ||
          (search?.no_of_days?.toString().includes(term)) ||
          (search?.no_of_nights?.toString().includes(term)) ||
          (search?.statename?.toLowerCase().includes(term)) 
        ));
      });
    }
    if (booking) {
      const searchTerms = booking.toLowerCase().split(' '); 
    
      data = data.filter((search) => { 
       
        return searchTerms.every(term => ( 
          (search?.ref_no?.toLowerCase().includes(term)) ||
          (search?.agentname?.toLowerCase().includes(term)) ||
          (search?.agentref?.toLowerCase().includes(term)) ||
          (search?.client_name?.toLowerCase().includes(term)) ||
          (search?.package_type?.toLowerCase().includes(term)) ||
          (search?.arrival?.toLowerCase().includes(term)) ||
          (search?.start_date?.toLowerCase().includes(term)) ||
          (search?.end_date?.toLowerCase().includes(term)) ||
          (search?.is_online?.toString().includes(term)) ||
          (term.toLowerCase() === "online" ? search?.is_online?.toString() === "true" : null)||
          (term.toLowerCase() === "offline" ? search?.is_online?.toString() === "false" : null)
        ));
      });
    }
    
    if (vehicle) {
      const searchTerms = vehicle.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.vendor_name && search.vendor_name.toLowerCase().includes(term)) || 
          (search?.vehicle_name_id && search.vehicle_name_id.toLowerCase().includes(term)) || 
          (search?.vehicle_reg_no && search.vehicle_reg_no.toLowerCase().includes(term)) || 
          (search?.year_of_vehicle_manufactured && search.year_of_vehicle_manufactured.toLowerCase().includes(term)) 
        ));
      }, data); 
    }
    if (advertisement) {
      const searchTerms = advertisement.toLowerCase().split(' '); 
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.title && search.title.toLowerCase().includes(term)) || 
          (search?.url && search.url.toLowerCase().includes(term)) || 
          (search?.content && search.content.toLowerCase().includes(term)) 
        ));
      }, data); 
    }

    if (driver) {

      const searchTerms = driver.toLowerCase().split(' '); 
    
      data = data.filter((search) => { 
       
        return searchTerms.every(term => ( 
          (search?.ref_no?.toLowerCase().includes(term)) ||
          (search?.vendor_name?.toLowerCase().includes(term)) ||
          (search?.driver_name?.toLowerCase().includes(term)) ||
          (search?.driver_contact_no?.toLowerCase().includes(term)) ||
          (search?.driving_license?.toLowerCase().includes(term)) ||
          (search?.city?.toLowerCase().includes(term)) 
        ));
      });
    }


    if (purchasebill) {
      
      const searchTerms = purchasebill.toLowerCase().split(' '); 

      
      data = data.filter((search) => { 
       
        return searchTerms.every(term => ( 
          (search?.ref_no?.toLowerCase().includes(term)) ||
          (search?.client_name?.toLowerCase().includes(term)) ||
          (search?.start_date?.toLowerCase().includes(term)) ||
          (search?.end_date?.toLowerCase().includes(term))
        ));
      });
    }

    

    if (driverqueue) {
      const searchTerms = driver.toLowerCase().split(' '); 
      data = data.filter((search) => { 
       
        return searchTerms.every(term => ( 
          (search?.ref_no?.toLowerCase().includes(term)) ||
          (search?.vendor_name?.toLowerCase().includes(term)) ||
          (search?.driver_name?.toLowerCase().includes(term)) ||
          (search?.driver_contact_no?.toLowerCase().includes(term)) ||
          (search?.driving_license?.toLowerCase().includes(term)) ||
          (search?.city?.toLowerCase().includes(term)) 
        ));
      });
    }
    
     
    if (contact) {
      const searchTerms = contact.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.name && search.name.toLowerCase().includes(term)) || 
          (search?.email_id && search.email_id.toLowerCase().includes(term)) || 
          (search?.mobile_no && search.mobile_no.toLowerCase().includes(term)) ||
          (search?.subject && search.subject.toLowerCase().includes(term)) 
        ));
      }, data); 
    }
    
    if (career) {
      const searchTerms = career.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.name && search.name.toLowerCase().includes(term)) || 
         (search?.job_roles && search.job_roles.toLowerCase().includes(term)) || 
         (search?.total_experience && String(search.total_experience).includes(term)) ||
          (search?.summary && search.summary.toLowerCase().includes(term)) 
        ));
      }, data); 
    }
    if (languagedriver) {
      const searchTerms = languagedriver.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.lang_driver && search.lang_driver.toLowerCase().includes(term)) 
        ));
      }, data); 
    }
    if (menu) {
      const searchTerms = menu.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.name && search.name.toLowerCase().includes(term)) || 

         (search?.id_parent && String(search.id_parent).includes(term)) ||
         (search?.id_sub_parent && String(search.id_sub_parent).includes(term)) ||
          
          (search?.position && String(search.position).includes(term)) 
        ));
      }, data); 
    }
    if (razorpaydetails) {
      const searchTerms = razorpaydetails.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.email && search.email.toLowerCase().includes(term)) || 
         (search?.id && search.id.toLowerCase().includes(term)) || 
         (search?.contact && search.contact.toLowerCase().includes(term)) || 
         (search?.order_id && search.order_id.toLowerCase().includes(term)) || 
         (search?.entity && search.entity.toLowerCase().includes(term)) || 
       
         (search?.amount && String(search.amount).includes(term)) ||
         (search?.currency && search.currency.toLowerCase().includes(term)) || 
         (search?.invoice_id && search.invoice_id.toLowerCase().includes(term)) ||
         (search?.status && search.status.toLowerCase().includes(term)) || 
         (search?.method && search.method.toLowerCase().includes(term)) || 
         (search?.amount_refunded && String(search.amount_refunded).includes(term)) ||
        
         (search?.refund_status && search.refund_status.toLowerCase().includes(term)) || 
         (search?.captured && String(search.captured).includes(term)) ||
        
         (search?.description && search.description.toLowerCase().includes(term)) || 
         (search?.bank && search.bank.toLowerCase().includes(term)) || 
         (search?.tax && String(search.tax).includes(term)) ||
      
         (search?.created_at && String(search.created_at).includes(term)) 
        
        ));
      }, data); 
    }
    if (razorpayorderdetails) {
      const searchTerms = razorpayorderdetails.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.id && search.id.toLowerCase().includes(term)) || 
         (search?.entity && search.entity.toLowerCase().includes(term)) || 
         (search?.amount && String(search.amount).includes(term)) ||
         (search?.amount_due && String(search.amount_due).includes(term)) ||
        
         (search?.currency && search.currency.toLowerCase().includes(term)) || 
         (search?.receipt && search.receipt.toLowerCase().includes(term)) || 
         (search?.offer_id && search.offer_id.toLowerCase().includes(term)) || 
         (search?.status && search.status.toLowerCase().includes(term)) || 
         (search?.attempts && String(search.attempts).includes(term)) ||
         (search?.created_at && String(search.created_at).includes(term)) ||
         (search?.amount_paid && String(search.amount_paid).includes(term)) 
          
        ));
      }, data); 
    }
    if (clientfeedback) {
      const searchTerms = clientfeedback.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.ref_no && search.ref_no.toLowerCase().includes(term)) || 
         (search?.start_date && search.start_date.toLowerCase().includes(term)) ||
         (search?.end_date && search.end_date.toLowerCase().includes(term)) ||
         (search?.arrival && search.arrival.toLowerCase().includes(term)) ||
         (search?.departure && search.departure.toLowerCase().includes(term)) ||
         (search?.client_name && search.client_name.toLowerCase().includes(term)) ||
         (search?.days_to_complete && search.days_to_complete.toLowerCase().includes(term)) ||
         (search?.ontour_feedback && search.ontour_feedback.toLowerCase().includes(term)) ||
         (search?.package_type && search.package_type.toLowerCase().includes(term)) ||
         (search?.company_name && search.company_name.toLowerCase().includes(term)) ||
         (search?.driver_name && search.driver_name.toLowerCase().includes(term)) ||
         (search?.vehicle_remark && search.vehicle_remark.toLowerCase().includes(term))
        ));
      }, data); 
    }
   
   
        
    if (permit) {
      const searchTerms = permit.toLowerCase().split(' ');
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => {
          const matchesFromState = search?.from_state_name?.toLowerCase().includes(term);
          const matchesToState = search?.to_state_name?.toLowerCase().includes(term);
          const matchesVehicleOrPermit = search?.vehicle_type_id?.some((id) => {
            const vehicleTypeName = search?.vehicle_type_names?.[id]?.toLowerCase();
            const permitValue = search?.permit?.[id]?.toString().toLowerCase();
            return (vehicleTypeName && vehicleTypeName.includes(term)) || 
                   (permitValue && permitValue.includes(term));
          });
    
          return matchesFromState || matchesToState || matchesVehicleOrPermit;
        });
      }, data || []);
    }
    
    
    if (partialpayment) {
      const searchTerms = partialpayment.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
    
          ( 
        (search?.less_than && search.less_than.toLowerCase().includes(term)) || 
         (search?.more_than && search.more_than.toLowerCase().includes(term)) 
        ));
      }, data); 
    }
    if (subusers) {
      const searchTerms = subusers.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.agent_email && search.agent_email.toLowerCase().includes(term)) || 
         (search?.agent_reference && search.agent_reference.toLowerCase().includes(term)) || 
         (search?.reference_user && search.reference_user.toLowerCase().includes(term)) || 
         (search?.username && search.username.toLowerCase().includes(term)) || 
         (search?.email && search.email.toLowerCase().includes(term)) || 
         (search?.mobile && search.mobile.toLowerCase().includes(term)) || 
          (search?.role_name && search.role_name.toLowerCase().includes(term)) 
        ));
      }, data); 
    }
    if (billpaymentreport) {
      const searchTerms = billpaymentreport.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.client_name && search.client_name.toLowerCase().includes(term)) || 
         (search?.ref_no && search.ref_no.toLowerCase().includes(term)) || 
         (search?.start_date && search.start_date.toLowerCase().includes(term)) || 
         (search?.end_date && search.end_date.toLowerCase().includes(term)) || 
         (search?.arrival && search.arrival.toLowerCase().includes(term)) || 
         (search?.purchase_rate && search.purchase_rate.toLowerCase().includes(term)) || 
         (search?.tds && search.tds.toLowerCase().includes(term)) || 
         (search?.vendor_name && search.vendor_name.toLowerCase().includes(term)) || 
         (search?.paid_amount && search.paid_amount.toLowerCase().includes(term)) || 
          (search?.total_trip_advance_paid && search.total_trip_advance_paid.toLowerCase().includes(term)) ||
          (search?.trip_date && search.trip_date.toLowerCase().includes(term)) ||
          (search?.vehicle_driver_change_remark && search.vehicle_driver_change_remark.toLowerCase().includes(term)) ||
          (search?.remaining_individual_amt && search.remaining_individual_amt.toLowerCase().includes(term))
        ));
      }, data); 
    }
    if (tripadvance) {
      const searchTerms = tripadvance.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.ref_no && search.ref_no.toLowerCase().includes(term)) || 
         (search?.client_name && search.client_name.toLowerCase().includes(term)) || 
         (search?.start_date && search.start_date.toLowerCase().includes(term)) || 
         (search?.arrival && search.arrival.toLowerCase().includes(term)) || 
         (search?.departure && search.departure.toLowerCase().includes(term)) || 
         (search?.vehicle_type && search.vehicle_type.toLowerCase().includes(term)) || 
         (search?.vendor_name && search.vendor_name.toLowerCase().includes(term)) || 
         (search?.trip_advance_request && String(search.trip_advance_request).includes(term)) ||
        
         (search?.trip_advance_paid && search.trip_advance_paid.toLowerCase().includes(term)) || 
         (search?.approval_status && search.approval_status.toLowerCase().includes(term)) || 
         (search?.paid_status && search.paid_status.toLowerCase().includes(term)) || 
         (search?.paid_remark && search.paid_remark.toLowerCase().includes(term)) || 
         (search?.vehicle_driver_change_remark && search.vehicle_driver_change_remark.toLowerCase().includes(term))
        ));
      }, data); 
    }
    if (paymentdetails) {
      const searchTerms = paymentdetails.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.agent_id && search.agent_id.toLowerCase().includes(term)) || 
        (search?.ref_no && search.ref_no.toLowerCase().includes(term)) || 
         (search?.order_id && search.order_id.toLowerCase().includes(term)) || 
         (search?.payment_id && search.payment_id.toLowerCase().includes(term)) || 
         (search?.amount && String(search.amount).includes(term)) ||
         (search?.customer_name && search.customer_name.toLowerCase().includes(term)) || 
         (search?.payment_status && search.payment_status.toLowerCase().includes(term)) || 
         (search?.payment_type && search.payment_type.toLowerCase().includes(term)) || 
       
        
         (search?.previous_balance && String(search.previous_balance).includes(term)) || 
       
         (search?.current_balance && String(search.current_balance).includes(term))|| 
         (search?.is_recharge && String(search.is_recharge).includes(term))
      
        
        ));
      }, data); 
    }
    if (jobtitle) {
      const searchTerms = jobtitle.toLowerCase().split(' '); 
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ( 
        (search?.job_roles && search.job_roles.toLowerCase().includes(term))
        ));
      }, data); 
    }
    if (subscribe) {
      const searchTerms = subscribe.toLowerCase().split(' ');
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) =>
          (
            (search?.email && search.email.toLowerCase().includes(term)) ||
            (term === "active" && search?.active === 1) ||
            (term === "inactive" && search?.active === 0)
          )
        );
      }, data);
    }
    if (itineraryperiodic) {
      const searchTerms = itineraryperiodic.toLowerCase().split(' ');
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => {
          const formattedStartDate = search.start_date 
            ? dayjs(search.start_date).format('DD-MM-YYYY') 
            : '';
          const formattedEndDate = search.end_date 
            ? dayjs(search.end_date).format('DD-MM-YYYY') 
            : '';
      
          return (
            (search?.city_names && search.city_names.toLowerCase().includes(term)) ||
            (search?.vehicle_type_id && search.vehicle_type_id.some(id => {
              const typeName = search.vehicle_type_names[id];
              const hike = search.hike?.[id]?.toString().toLowerCase();
              return (
                (typeName && typeName.toLowerCase().includes(term)) ||
                (hike && hike.includes(term))
              );
            })) ||
            (formattedStartDate && formattedStartDate.includes(term)) ||
            (formattedEndDate && formattedEndDate.includes(term))
          );
        });
      }, data);
      
    }
    
    if (airbasic) {
      const searchTerms = airbasic.toLowerCase().split(' '); 
    
      data = data.filter((search) => {
        return searchTerms.every(term => (
          (search?.name_of_airport?.toLowerCase().includes(term)) ||
          (search?.vehicle_type_id?.some(id => {
            const typeName = search.vehicle_type_names[id];
            const minRate = search.min_rate[id]?.toString();  
            const minKm = search.min_km[id]?.toString();
            const extraKm = search.extra_km[id]?.toString();
            const prime = search.prime[id]?.toString();
            
            return (
              (typeName && typeName.toLowerCase().includes(term)) ||
              (minRate && minRate.includes(term)) ||
              (minKm && minKm.includes(term)) ||
              (extraKm && extraKm.includes(term)) ||
              (prime && prime.includes(term))
            );
          }))
        ));
      });
    }
    
    
    if (airPeriodicday) {
      const searchTerms = airPeriodicday.toLowerCase().split(' ');
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => {
          const formattedStartDate = search.start_date
            ? dayjs(search.start_date).format('DD-MM-YYYY')
            : '';
          const formattedEndDate = search.end_date
            ? dayjs(search.end_date).format('DD-MM-YYYY')
            : '';
    
          return (
            ((search?.city_names && search.city_names.toLowerCase().includes(term)) ||
            (search?.vehicle_type_id && search.vehicle_type_id.some(id => {
              const typeName = search.vehicle_type_names[id];
              const hike = search.hike?.[id]?.toString().toLowerCase();
              return (typeName && typeName.toLowerCase().includes(term)) ||
                     (hike && hike.includes(term));
            })) ||
            (formattedStartDate && formattedStartDate.includes(term)) ||
            (formattedEndDate && formattedEndDate.includes(term))
            )
          );
        });
      }, data);
    }
    
    
    if (airPeriodictime) {
      const searchTerms = airPeriodictime.toLowerCase().split(' '); 
    
      data = data.filter((search) => {
        return searchTerms.every(term => (
          (search?.city_names?.toLowerCase().includes(term)) ||
          (search?.vehicle_type_names?.toLowerCase().includes(term)) ||
          (search?.start_time?.toLowerCase().includes(term)) || 
          (search?.end_time?.toLowerCase().includes(term)) ||  
          (search?.hike?.toString().toLowerCase().includes(term))  
        ));
      });
    }
    
      
    if (daybasic) {
      const searchTerms = daybasic.toLowerCase().split(' ');
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) =>
          ((search?.city && search.city.toLowerCase().includes(term)) || 
          
          (search?.vehicle_type_id?.some(id => {
            const typeName = search?.vehicle_type_names?.[id]; 
            const minRate = search?.min_rate?.[id]?.toString().toLowerCase();
            const minKm = search?.min_km?.[id]?.toString().toLowerCase();
            const extraKm = search?.extra_km?.[id]?.toString().toLowerCase();
            const driverBeta = search?.driver_beta?.[id]?.toString().toLowerCase();
            const nightAllowance = search?.night_allowance?.[id]?.toString().toLowerCase();
            const duration = search?.duration?.[id]?.toString().toLowerCase();
            const prime = search?.prime?.[id]?.toString().toLowerCase();
    
            return (typeName && typeName.toLowerCase().includes(term)) ||
                   (minRate && minRate.includes(term)) ||
                   (minKm && minKm.includes(term)) ||
                   (extraKm && extraKm.includes(term)) ||
                   (driverBeta && driverBeta.includes(term)) ||
                   (nightAllowance && nightAllowance.includes(term)) ||
                   (duration && duration.includes(term)) ||
                   (prime && prime.includes(term));
          })))
        );
      }, data);
    }
    
    
    if (agent) {
      const searchTerms = agent.toLowerCase().split(' ');
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ((search?.company_name && search.company_name.toLowerCase().includes(term)) || 
          (search?.reference_no && search.reference_no.toLowerCase().includes(term)) || 
          (search?.city_name && search.city_name.toLowerCase().includes(term)) || 
          (search?.state_name && search.state_name.toLowerCase().includes(term)) || 
          (search?.mobile_no && search.mobile_no.toLowerCase().includes(term)) || 
          (search?.email_id && search.email_id.toLowerCase().includes(term))
        ));
      }, data); 
    }
    
    if (dayperiodic) {
      const searchTerms = dayperiodic.toLowerCase().split(' ');
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => {
          const formattedStartDate = search.start_date 
            ? dayjs(search.start_date).format('DD-MM-YYYY') 
            : '';
          const formattedEndDate = search.end_date 
            ? dayjs(search.end_date).format('DD-MM-YYYY') 
            : '';
          
            return (
              ((search?.city_names && search.city_names.toLowerCase().includes(term)) ||
              (search?.vehicle_type_id && search.vehicle_type_id.some(id => {
                const typeName = search.vehicle_type_names[id];
                const hike = search.hike?.[id]?.toString().toLowerCase();
                return (typeName && typeName.toLowerCase().includes(term)) ||
                       (hike && hike.includes(term));
              })) ||
              (formattedStartDate && formattedStartDate.includes(term)) ||
              (formattedEndDate && formattedEndDate.includes(term))
              )
            );
          });
        }, data);
    }
    
    if (hourPeriodicday) {
      const searchTerms = hourPeriodicday.toLowerCase().split(' ');
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => {
          const formattedStartDate = search.start_date 
            ? dayjs(search.start_date).format('DD-MM-YYYY') 
            : '';
          const formattedEndDate = search.end_date 
            ? dayjs(search.end_date).format('DD-MM-YYYY') 
            : '';
      
          return (
            (search?.city_names && search.city_names.toLowerCase().includes(term)) ||
            (search?.vehicle_type_id && search.vehicle_type_id.some(id => {
              const typeName = search.vehicle_type_names[id];
              const hike = search.hike?.[id]?.toString().toLowerCase();
              return (
                (typeName && typeName.toLowerCase().includes(term)) ||
                (hike && hike.includes(term))
              );
            })) ||
            (formattedStartDate && formattedStartDate.includes(term)) ||
            (formattedEndDate && formattedEndDate.includes(term))
          );
        });
      }, data);
      
    }
    
    if (hourPeriodictime) {
      const searchTerms = hourPeriodictime.toLowerCase().split(' '); 
    
      data = data.filter((search) => {
        return searchTerms.every(term => (
          (search?.city_names?.toLowerCase().includes(term)) ||
          (search?.vehicle_type_names?.toLowerCase().includes(term)) ||
          (search?.hike?.toString().toLowerCase().includes(term))  ||
          (search?.start_time?.toLowerCase().includes(term)) || 
          (search?.end_time?.toLowerCase().includes(term)) 
        ));
      });
    }
    
    if (vendor) {
      const searchTerms = vendor.toLowerCase().split(' ');
    
      data = searchTerms.reduce((filteredData, term) => {   
        return filteredData.filter((search) => 
          ((search?.authorized_person && search.authorized_person.toLowerCase().includes(term)) || 
           (search?.reference_no && search.reference_no?.toLowerCase().includes(term)) || 
           (search?.company_name && search.company_name?.toLowerCase().includes(term)))|| 
          (search?.destination && search.destination?.toLowerCase().includes(term)) || 
          (search?.email && search.email?.toLowerCase().includes(term)) 
        );
      }, data);
    }
    if (vehicleModel) {
      const searchTerms = vehicleModel.toLowerCase().split(' ');
    
      data = searchTerms.reduce((filteredData, term) => {
        return filteredData.filter((search) => 
          ((search?.name && search.name.toLowerCase().includes(term)) || 
           (search?.vehcilecategory && search.vehcilecategory?.toLowerCase().includes(term)) 
          )
        );
      }, data);
    }
    
    if (vehicleColor) {
    
      data = data.filter(
        (search) =>
        ((search)?search["Vehicle Color"].toLowerCase().includes(vehicleColor.toLowerCase()):false)
          
      );
    }
    if (vehicleBrand) {
    
      data = data.filter(
        (search) =>
        ((search)?search["Vehicle Brand"].toLowerCase().includes(vehicleBrand.toLowerCase()):false)
         
      );
    }
    if (vehicleSeats) {
      data = data.filter(
        (search) =>
        ((search)?search["Vehicle Seats"].toLowerCase().includes(vehicleSeats.toLowerCase()):false)
         
      );
    }
    //country filtering
    if (country) {
      data = data.filter(
        (cou) =>
          cou?.name?.toLowerCase().includes(country.toLowerCase()) ||
          cou?.iso_code?.toLowerCase().includes(country.toLowerCase())
      );
    }


    return data;
  }, [
    time,
    data,
    location.pathname,
    filter,
    sortedField,
    searchUser,
    purchasebill,
    vendor,
    vendorRequest,
    vehicleCategory,
    vehicletype,
    hourbasic,
    seoManageCity,
    seoPage,
    itinerarybasic,
    itineraryperiodic,
    topselling,
    booking,
    driver,
    driverqueue,
    vehicle,
    advertisement,
    contact,
    career,
    languagedriver,
    menu,

    razorpaydetails,
    razorpayorderdetails,
    clientfeedback,
    permit,
    partialpayment,
    subusers,
    billpaymentreport,
    tripadvance,
    paymentdetails,
    jobtitle,
    subscribe,
    airbasic,
    airPeriodicday,
    airPeriodictime,
    daybasic,
    agent,
    dayperiodic,
    hourPeriodicday,
    hourPeriodictime,
    vehicleModel,
    vehicleAllot,
    vendorAllot,
    vehicleBrand,
    vehicleColor,
    vehicleSeats,
    status,
    country,
  ]);

  //pagination functionality start
  const resultsPerPage = itemsPerPage;
  const totalResults = serviceData?.length;
  const handleChangePage = (p) => {
    setCurrentPage(p);
  };
  useEffect(() => {
    // Calculate the paginated data only if `serviceData` is available and `resultsPerPage` is stable.
    if (serviceData && serviceData.length > 0) {
      const paginatedData = serviceData.slice(
        (currentPage - 1) * resultsPerPage,
        currentPage * resultsPerPage
      );
  
      setDataTable(paginatedData); // Only update if `paginatedData` differs from the current `dataTable`
    }
  }, [serviceData, currentPage, resultsPerPage]);
  //pagination functionality end
  //table form submit function for search start
  
  const handleSubmitUser = (e) => {
    e.preventDefault();
    setSearchUser(userRef.current.value);
  };
  const handleSubmitVendor = (e) => {
    e.preventDefault();
    setVendor(vendorRef.current.value);
  };
  const handleSubmitVendorRequest = (e) => {
    e.preventDefault();
    setVendorRequest(vendorRequestRef.current.value);
  }
  const handleSubmitVehicleCategory = (e) => {
    e.preventDefault();
    setVehicleCategory(vehicleCategoryRef.current.value);   
  };   
  const handleSubmitVehicleType = (e) => {
    e.preventDefault();
    setVehicletype(vehicleTypeRef.current.value);   
  }; 
  const handleSubmitHourRentalBasicRate = (e) => {
    e.preventDefault();
    setHourBasic(hourRentalBasicRateRef.current.value);
  };
  const handleSubmitFixedItinerary = (e) => {  
    e.preventDefault();
    setItineraryBasic(fixedItineraryRef.current.value);
  };
  const handleSubmitFixedItineraryPeriodicHike = (e) => {
    e.preventDefault();
    setItineraryPeriodic(fixedItineraryPeriodicHikeRef.current.value);
  };
  const handleSubmitSeoManageCity = (e) => {
    e.preventDefault();
    setSeoManageCity(SeoManageCityRef.current.value);
  };
  const handleSubmitSeoPage = (e) => {
    e.preventDefault();
    setSeoPage(seoPageRef.current.value);
  };
  const handleSubmitTopSelling = (e) => {
    e.preventDefault();
    setTopselling(topSellingRef.current.value);
  };
  const handleSubmitBookings = (e) => {
    e.preventDefault();
    setBooking(bookingRef.current.value);
  };
  const handleSubmitVehicle = (e) => {
    e.preventDefault();
    setVehicle(vehicleRef.current.value);
  }; 
  const handleSubmitAdvertisement = (e) => {
    e.preventDefault();
    setAdvertisement(advertisementRef.current.value);
  }; 
  const handleSubmitContact = (e) => {
    e.preventDefault();
    setContact(contactRef.current.value);
  }; 
  const handleSubmitCareer = (e) => {
    e.preventDefault();
    setCareer(careerRef.current.value);
  }; 
  const handleSubmitLanguageDriver = (e) => {
    e.preventDefault();
    setLanguageDriver(languagedriverRef.current.value);
  }; 
  const handleSubmitMenu = (e) => {
    e.preventDefault();
    setMenu(menuRef.current.value);
  }; 
  const handleSubmitRazorpayDetails = (e) => {
    e.preventDefault();
    setRazorpayDetails(razorpaydetailsRef.current.value);
  }; 
  const handleSubmitRazorpayOrderDetails = (e) => {
    e.preventDefault();
    setRazorpayOrderDetails(razorpayorderdetailsRef.current.value);
  }; 
  const handleSubmitClientFeedback = (e) => {
    e.preventDefault();
    setClientFeedback(clientfeedbackRef.current.value);
  }; 
  const handleSubmitPermit = (e) => {
    e.preventDefault();
    setPermit(permitRef.current.value);
  }; 
  const handleSubmitPartialPayment = (e) => {
    e.preventDefault();
    setPartialPayment(partialpaymentRef.current.value);
  }; 
  const handleSubmitSubusers = (e) => {
    e.preventDefault();
    setSubusers(subusersRef.current.value);
  }; 
  const handleSubmitBillPaymentReport = (e) => {
    e.preventDefault();
    setBillPaymentReport(billpaymentreportRef.current.value);
  }; 
  const handleSubmitTripadvance= (e) => {
    e.preventDefault();
    setTripadvance(tripadvanceRef.current.value);
  }; 
  const handleSubmitPaymentDetails= (e) => {
    e.preventDefault();
    setPaymentDetails(paymentdetailsRef.current.value);
  }; 
  const handleSubmitJobtitle = (e) => {
    e.preventDefault();
    setJobtitle(jobtitleRef.current.value);
  }; 
  const handleSubmitSubscribe = (e) => {
    e.preventDefault();
    setSubscribe(subscribeRef.current.value);
  }; 
    

  
  const handleSubmitDriver = (e) => {
    e.preventDefault();
    setDriver(driverRef.current.value);
  };

  const handleSubmitBill = (e) => {
    e.preventDefault();
    setPurchaseBill(billRef.current.value);
  };
  

  const handleSubmitDriverqueue = (e) => {
    e.preventDefault();
    setDriverqueue(driverqueueRef.current.value);
  };
  const handleSubmitDayRentalBasicRate = (e) => {
    e.preventDefault();
    setDayBasic(dayRentalBasicRateRef.current.value);    
  };
  const handleSubmitAgents = (e) => {
    e.preventDefault();
    setAgent(agentsRef.current.value);    
  };
  const handleSubmitVehicleAllot = (e) => {
    e.preventDefault();
    setVehicleAllot(vehicleAllotRef.current.value);    
  };
  const handleSubmitVendorAlot = (e) => {
    e.preventDefault();
    setVendorAlot(vendoralotRef.current.value);
  };

  const handleSubmitAirportPickupBasicRate = (e) => {
    e.preventDefault();
    setAirBasic(airportPickupBasicRateRef.current.value);   
  };
  const handleSubmitAirportPickupPeriodicHikeDay = (e) => {
    e.preventDefault();
    setAirPeriodicDay(airportPickupPeriodicHikeDayRef.current.value);
  };
  const handleSubmitAirportPickupPeriodicHikeTime = (e) => {
    e.preventDefault();
    setAirPeriodicTime(airportPickupPeriodicHikeTimeRef.current.value);
  };
  const handleSubmitDayRentalPeriodicHikeDay = (e) => {
    e.preventDefault();
    setDayPeriodic(dayRentalPeriodicHikeDayRef.current.value);
  };
  const handleSubmitHourRentalPeriodicHikeDay = (e) => {
    e.preventDefault();
    setHourPeriodicDay(hourRentalPeriodicHikeDayRef.current.value);
  };
  const handleSubmitHourRentalPeriodicHikeTime = (e) => {
    e.preventDefault();
    setHourPeriodicTime(hourRentalPeriodicHikeTimeRef.current.value);
  };
  const handleSubmitVehicleModel = (e) => {
    e.preventDefault();
    setVehicleModel(vehicleModelRef.current.value);
  };
  const handleSubmitVehicleBrand = (e) => {
    e.preventDefault();
    setVehicleBrand(vehicleBrandRef.current.value);
  };
  const handleSubmitVehicleColor = (e) => {
    e.preventDefault();
    setVehicleColor(vehicleColorRef.current.value);
  };

  const handleSubmitVehicleSeats = (e) => {
    e.preventDefault();
    setVehicleSeats(vehicleSeatsRef.current.value);
  };
  const handleSubmitCountry = (e) => {
    e.preventDefault();
    setCountry(countryRef.current.value);
  };

  // table form submit function for search end
  // handle submit multiple product data with csv format
  const handleOnDrop = (data) => {
    for (let i = 0; i < data.length; i++) {
      newProducts.push(data[i].data);
    }
  };

  return {
    vehicleModelRef,
    vehicleBrandRef,
    vehicleColorRef,
    vehicleSeatsRef,
    userRef,
    vehicleCategoryRef,
    vehicleTypeRef,
    hourRentalBasicRateRef,
    fixedItineraryRef,
    SeoManageCityRef,
    seoPageRef,
    fixedItineraryPeriodicHikeRef,
    topSellingRef,
    bookingRef,
    driverRef,
    billRef,
    driverqueueRef,
    vehicleRef,
   advertisementRef,
   contactRef,
   careerRef,
   languagedriverRef,
   menuRef,
   razorpaydetailsRef,
   razorpayorderdetailsRef,
   clientfeedbackRef,
   permitRef,
   partialpaymentRef,
   subusersRef,
   billpaymentreportRef,
   tripadvanceRef,
   paymentdetailsRef,
   jobtitleRef,
   subscribeRef,
    dayRentalBasicRateRef,
    agentsRef,
    vehicleAllotRef,
    vendoralotRef,
    airportPickupBasicRateRef,
    airportPickupPeriodicHikeDayRef,
    airportPickupPeriodicHikeTimeRef,
    dayRentalPeriodicHikeDayRef,
    hourRentalPeriodicHikeDayRef,
    hourRentalPeriodicHikeTimeRef,
    vendorRef,
    vendorRequestRef,
    searchRef,
    couponRef,
    orderRef,
    categoryRef,
    attributeRef,
    pending,
    processing,
    delivered,
    todayOrder,
    monthlyOrder,
    totalOrder,
    setFilter,
    setSortedField,
    setStatus,
    time,
    setTime,
    handleChangePage,
    totalResults,
    resultsPerPage,
    dataTable,
    serviceData,
    handleSubmitUser,
    handleSubmitVehicleCategory,
    handleSubmitVehicleType,
    handleSubmitHourRentalBasicRate,
    handleSubmitFixedItinerary,
    handleSubmitFixedItineraryPeriodicHike,
    handleSubmitSeoManageCity,
    handleSubmitSeoPage,
    handleSubmitTopSelling,
    handleSubmitBookings,
    handleSubmitDriver,
    handleSubmitBill,
    handleSubmitVendorAlot,
    handleSubmitDriverqueue,
    handleSubmitVehicle,
    handleSubmitAdvertisement,
    handleSubmitContact,
    handleSubmitCareer,
    handleSubmitLanguageDriver,
    handleSubmitMenu,
    handleSubmitRazorpayDetails,
    handleSubmitRazorpayOrderDetails,
    handleSubmitClientFeedback,
    handleSubmitPermit,
    handleSubmitPartialPayment,
    handleSubmitSubusers,
    handleSubmitBillPaymentReport,
    handleSubmitTripadvance,
    handleSubmitPaymentDetails,
    handleSubmitJobtitle,
    handleSubmitSubscribe,
    handleSubmitDayRentalBasicRate,
    handleSubmitAgents,
    handleSubmitVehicleAllot,
    handleSubmitAirportPickupBasicRate,
    handleSubmitAirportPickupPeriodicHikeDay,
    handleSubmitAirportPickupPeriodicHikeTime,
    handleSubmitDayRentalPeriodicHikeDay,
    handleSubmitHourRentalPeriodicHikeDay,
    handleSubmitHourRentalPeriodicHikeTime,
    handleSubmitVehicleModel,
    handleSubmitVehicleBrand,
    handleSubmitVehicleColor,
    handleSubmitVehicleSeats,
    handleSubmitVendor,
    handleSubmitVendorRequest,
    handleOnDrop,
    countryRef,
    country,
    setCountry,
    zone,
    setZone,
    handleSubmitCountry,
    languageRef,
    isDisabled,
    taxRef,
    currencyRef,
    currentPage,
  };
};

export default useFilter;
